module.exports = "<p>\n  login-avet works!\n</p>\n"